import { BaseModel } from "@Core";

export enum IntervalUnit {
    SECONDS = 1,
    MINUTES = 2,
    HOURS = 3,
    DAYS = 4
}

export enum StorageFilenameType {
    TYPE_0 = 0, 
}

export enum UploadMethod {
    FTP = 1,
    SMTP = 2,
    HTTP = 3
}

export interface NotifyItem {
    Index: number;
    Enable: number;
    Url: string;
    User: string;
    Password: string;
}

export interface ScheduleItem {
    ScheduleIndex: number;
    Schedule: string; 
}

export interface PTZSnapShotSetting extends BaseModel {
    DevMac: string;
    TimingSnapshotEnable: number; 
    IntervalValue: number; 
    IntervalUnit: IntervalUnit; 
    SaveIntoStorage: number; 
    StorageFilenameType: StorageFilenameType; 
    StorageBaseFilename: string; 
    UploadViaFtp: number; 
    UploadViaSmtp: number; 
    UploadViaHttp: number; 
    NotifyList: NotifyItem[]; 
    ScheduleList: ScheduleItem[]; 
}
